(() => {
  const initCarousel = (root) => {
    const list = root.querySelector('[data-vc-list]');
    const items = Array.from(root.querySelectorAll('[data-vc-item]'));
    const btnPrev = root.querySelector('[data-vc-prev]');
    const btnNext = root.querySelector('[data-vc-next]');
    const btnsVolume = root.querySelectorAll('[data-vc-volume]');

    let isMuted = true;

    if (!list || items.length === 0) return;

    let activeIndex = 3;

    const playVideo = (idx) => {
      const video = items[idx].querySelector('video');

      if (video) {
        video.play().catch(() => { /* ignore */ });
        video.currentTime = 0;
      }
    };

    const pauseVideo = (idx) => {
      const video = items[idx].querySelector('video');

      if (video) {
        video.pause();
        video.muted = isMuted;
        video.currentTime = 0;
      }
    };

    const setActive = (idx) => {
      items.forEach((el, i) => {
        pauseVideo(i);
        el.classList.toggle('is-active', i === idx)
      });
      if (btnPrev) btnPrev.disabled = idx <= 0;
      if (btnNext) btnNext.disabled = idx >= items.length - 1;

      playVideo(idx);

      activeIndex = idx;
    };

    const scrollToIndex = (idx) => {
      const el = items[idx];
      if (!el) return;

      const screenCenter = window.innerWidth / 2;
      const elCenter = el.getBoundingClientRect().x + el.getBoundingClientRect().width / 2;
      const oldDelta = parseFloat(list.style.transform.match(/translate\(([-\d.]+)px, 0px\)/)?.[1] || 0);
      const delta = screenCenter - elCenter + oldDelta;

      list.style.transform = `translate(${delta}px, 0px)`;
    };

    const go = (dir) => {
      const current = activeIndex;
      const next = Math.min(items.length - 1, Math.max(0, current + dir));

      if (next === current) return;
      scrollToIndex(next);
      setActive(next);
    };

    setActive(activeIndex);
    requestAnimationFrame(() => scrollToIndex(activeIndex));

    btnPrev && btnPrev.addEventListener('click', () => go(-1));
    btnNext && btnNext.addEventListener('click', () => go(1));
    btnsVolume.forEach((btnVolume) => {
      btnVolume.addEventListener('click', () => {
        const mutedIcon = root.querySelectorAll('[data-vc-volume-icon-muted]');
        const unmutedIcon = root.querySelectorAll('[data-vc-volume-icon-unmuted]');
        const video = items[activeIndex].querySelector('video');

        if (isMuted) {
          mutedIcon.forEach(icon => icon.style.display = 'none');
          unmutedIcon.forEach(icon => icon.style.display = 'block');
        } else {
          mutedIcon.forEach(icon => icon.style.display = 'block');
          unmutedIcon.forEach(icon => icon.style.display = 'none');
        }
        
        isMuted = !isMuted;
        if (video) {
          video.muted = isMuted;
        }
      });
    });

    let raf = null;
    list.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        setActive(activeIndex);
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-videos-stage]').forEach(initCarousel);
  };

  document.addEventListener('shopify:section:load', (e) => {
    const sectionRoot = e.target.querySelector('[data-videos-stage]');
    if (sectionRoot) initCarousel(sectionRoot);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
